module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/POLITICS-INTERNATIONAL RELATIONS-a53f364824bfdd2184ba5f1cb4d92e36.png";